import React, { useState } from 'react';
import { Button, Modal, Icon } from 'semantic-ui-react';


import AddAdditionalCharge from './addAdittionalCharge';


const PoDetails = (props) => {
    const [modalOpen, setmodalOpen] = useState(false);

    let handleOpen = () => setmodalOpen(true);
    let handleClose = () => {
        setmodalOpen(false);
    };
    
    return (
        <Modal
            style={{ overflow: "inherit" }}
            open={modalOpen}
            onClose={handleClose}
            size="fullscreen"
            trigger={
                <Button
                    type="button"
                    onClick={() => handleOpen()}
                    size="mini"
                    circular
                    basic className="ml-2 w3-tiny"
                    icon
                >
                    <Icon name="info" color="grey" size='small' />

                </Button >
            }

        >
            <Modal.Content>
                <AddAdditionalCharge 
                    billmode="view" 
                    poId={props.poId} 
                    poReferenceNo={props.poReferenceNo}
                    masterState={props.masterState} 
                    vendorStateId={props.vendorStateId} 
                    isGstApplicable={props.isGstApplicable} 
                    formValues={props.formValues} 
                    updatePurchaseOrder={props.updatePurchaseOrder} 
                    getVendorPurchaseOrder={props.getVendorPurchaseOrder}
                    handleClose={handleClose}
                    setInitialize={props.setInitialize}
                    viewmode={props.viewmode}
                    editmode={props.editmode}
                    vendorData={props.vendorData}
                />
            </Modal.Content>
        </Modal >
    )}


export default PoDetails
